export enum DatePreset {
    LastSevenDays = 0,
    LastMonth = 1,
    ThisYear = 2,
}
